import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGridInstance } from "./actions";
import { selectGridInstance } from "./selector";
import { useTradeHistoryRowData } from "state/analytics";
import { selectSelectedIsDisplayRgl } from "state/selections/selectors";
import SelectionState from "state/selections/SelectionState";
import { useBetaColumnDefinitions } from "state/betas/hooks";
import { selectHoldingColumnDefs as holdingColumnDef } from 'state/holdingAttributes/selectors';

export const useGridInstance = () => {
  const dispatch = useDispatch();

  return [
    useSelector(selectGridInstance),
    useCallback((gridInstace) => dispatch(setGridInstance(gridInstace)), [
      dispatch,
    ]),
  ];
};

export const useRowData = () => {
  return useTradeHistoryRowData();
};

export const useColumnDefinitions = () => {
  return [
    {
      headerName: "Entity Id",
      field: "entityId",
      colId: "entityId",
      width: 60,
    },
    {
      headerName: "Major",
      field: "major",
      colId: "major",
      width: 60,
    },
    {
      headerName: "Minor",
      field: "minor",
      colId: "minor",
      width: 60,
    },
    {
      headerName: "Wrap Account",
      field: "wrapAccount",
      colId: "wrapAccount",
      width: 60,
    },
    {
      headerName: "Entity Name",
      field: "entityName",
      colId: "entityName",
      width: 200,
    },
    {
      headerName: "Product",
      field: "productDescription",
      colId: "productDescription",
      width: 150,
    },
    {
      headerName: "RepSecId",
      field: "repSecId",
      colId: "repSecId",
      width: 80,
    },
    {
      headerName: "Cusip",
      field: "cusip",
      colId: "cusip",
      width: 80,
    },
    {
      headerName: "CUSIP9",
      field: "cusipNine",
      colId: "cusipNine",
      width: 80,
    },
    {
      headerName: "Security Name",
      field: "securityName",
      colId: "securityName",
      width: 300,
    },
    {
      headerName: "Instrument Type",
      field: "instrumentType",
      colId: "instrumentType",
      width: 80,
    },
    {
      headerName: "Offering Market",
      field: "offeringMarket",
      colId: "offeringMarket",
      width: 80,
    },
    {
      headerName: "Trade Date",
      field: "tradeDate",
      colId: "tradeDate",
      width: 80,
    },
    {
      headerName: "Tax Date",
      field: "taxDate",
      colId: "taxDate",
      width: 80,
    },
    {
      headerName: "Cancel",
      field: "cancelInd",
      colId: "cancelInd",
      width: 80,
    },
    {
      headerName: "Transaction Code",
      field: "transactionCode",
      colId: "transactionCode",
      width: 80,
    },
    {
      headerName: "Transaction Code Desc",
      field: "transactionDesc",
      colId: "transactionDesc",
      width: 150

    },
    {
      headerName: "Transaction Effect",
      field: "buySellEffect",
      colId: "buySellEffect",
      width: 80,
    },

    {
      headerName: "Trade Price Local",
      field: "tradePriceLocal",
      colId: "tradePriceLocal",
      width: 60,
    },
    {
      headerName: "Trade Price Base",
      field: "tradePriceBase",
      colId: "tradePriceBase",
      width: 80,
    },
    {
      headerName: "Qty Traded",
      field: "qtyTraded",
      colId: "qtyTraded",
      width: 100,
    },
    {
      headerName: "Market Value Base",
      field: "totalMarketValBase",
      width: 100,
      colId: "totalMarketValBase",
    },
    {
      headerName: "Market Value USD",
      field: "totalMarketValUsd",
      colId: "totalMarketValUsd",
      width: 100,
    },
    {
      headerName: "Effective Date",
      field: "effectiveDate",
      colId: "effectiveDate",
      width: 80,
    },
    {
      headerName: "Settlement Date",
      field: "settlementDate",
      colId: "settlementDate",
      width: 80,
    },
    {
      headerName: "Cancel Eff Date",
      field: "cancelEffDate",
      colId: "cancelEffDate",
      width: 80,
    },

    {
      headerName: "Trader Id",
      field: "traderId",
      colId: "traderId",
      width: 60,
    },
    {
      headerName: "Executing Broker",
      field: "executingBroker",
      colId: "executingBroker",
      width: 80,
    },
    {
      headerName: "Executing Broker Name",
      field: "executingBrokerName",
      colId: "executingBrokerName",
      width: 80,
    },
    {
      headerName: "Traded Yield",
      field: "tradedYield",
      colId: "tradedYield",
      width: 60,
    },
    {
      headerName: "After weight",
      field: "afterWeight",
      colId: "afterWeight",
      width: 60,
    },
    {
      headerName: "Before weight",
      field: "beforeWeight",
      colId: "beforeWeight",
      width: 60,
    },
    {
      headerName: "Traded weight",
      field: "tradeWeight",
      colId: "tradeWeight",
      width: 60,
    },
    {
      headerName: "MSAA Bucket Code",
      field: "msaaBucketCode",
      colId: "msaaBucketCode",
      width: 80
    },
    {
      headerName: "MSAA Bucket",
      field: "msaaBucketDescription",
      colId: "msaaBucketDescription",
      width: 80,
    },
    {
      headerName: "Abs MSAA Sector",
      field: "absMsaaSector",
      colId: "absMsaaSector",
      width: 80,
    },
    {
      headerName: "Muni Sector",
      field: "muniSector",
      colId: "muniSector",
      width: 80,
    },
    {
      headerName: "MSAA Breakout",
      field: "msaaBreakout",
      colId: "msaaBreakout",
      width: 80
    },
    {
      headerName: "Years To Eff Maturity",
      field: "yearsToEffectiveMaturity",
      colId: "yearsToEffectiveMaturity",
      width: 60,
    },
    {
      headerName: "Eff Duration",
      field: "effectiveDuration",
      colId: "effectiveDuration",
      width: 60,
    },
    {
      headerName: "Default Sec Id",
      field: "defaultSecurityId",
      colId: "defaultSecurityId",
      width: 60,
    },
    {
      headerName: "ISIN",
      field: "isin",
      colId: "isin",
      width: 60,
    },
    {
      headerName: "Ticker",
      field: "ticker",
      colId: "ticker",
      width: 60,
    },
    {
      headerName: "Issuer",
      field: "issuerCode",
      colId: "issuerCode",
      width: 60,
    },
    {
      headerName: "Securitized Strategy",
      field: "securitizedStrategy",
      colId: "securitizedStrategy",
      width: 80,
    },
    {
      headerName: "Securitized Sub Strategy",
      field: "securitizedSubStrategy",
      colId: "securitizedSubStrategy",
      width: 80,
    },
    {
      headerName: "Securitized Abs Strategy Sub Strategy",
      field: "securitizedAbsStrategySubStrategy",
      colId: "securitizedAbsStrategySubStrategy",
      width: 80,
    },
    {
      headerName: "Block Order",
      field: "blockOrder",
      colId: "blockOrder",
      width: 60,
    },
    {
      headerName: "G Spread",
      field: "gSpread",
      colId: "gSpread",
      width: 60,
    },
    {
      headerName: "Treasury Spread",
      field: "tsySpread",
      colId: "tsySpread",
      width: 60,
    },
    {
      headerName: "Swap Deal Spread",
      field: "swapDealSpread",
      colId: "swapDealSpread",
      width: 60,
    },
    {
      headerName: "Trader Comments",
      field: "traderComments",
      colId: "traderComments",
      width: 300,
   //   tooltipField: "traderComments",
    },
    {
      headerName: "Special Comments",
      field: "specialInst",
      colId: "specialInst",
      width: 250,
     // tooltipField: "specialInst",
    },
    {
      headerName: "Broker Comments",
      field: "brokerComment",
      colId: "brokerComment",
      width: 200,
   //   tooltipField: "brokerComment",
    },
    {
      headerName: "Oasis Comment",
      field: "expComment",
      colId: "expComment",
      width: 150,
     // tooltipField: "expComment",
    },
    {
      headerName: "Market Value USD net",
      field: "totalMarketValUsdNet",
      colId: "totalMarketValUsdNet",
      width: 100,
    },
    {
      headerName: "Quantity Traded Net",
      field: "qtyTradedNet",
      colId: "qtyTradedNet",
      width: 100,
    },
    {
      headerName: "Major/Minor",
      field: "majorMinor",
      colId: "majorMinor",
      width: 50,
    },
    {
      headerName: "Market Value Local",
      field: "marketValueLocal",
      colId: "marketValueLocal",
      width: 100,
    },
    {
      headerName: "Local Currency Code",
      field: "localCurrencyCode",
      colId: "localCurrencyCode",
      width: 60,
    },
    {
      headerName: "Coupon",
      field: "coupon",
      colId: "coupon",
      width: 60,
    },
    {
      headerName: "Maturity Date",
      field: "maturityDate",
      colId: "maturityDate",
      width: 80,
    },
    {
      headerName: "Zero Volatility Spread",
      field: "zeroVolatilitySpread",
      colId: "zeroVolatilitySpread",
      width: 80,
    },
    {
      headerName: "Standard Poors Rating",
      field: "standardPoorsRating",
      colId: "standardPoorsRating",
      width: 80,
    },
    {
      headerName: "Fitch Rating",
      field: "fitchRating",
      colId: "fitchRating",
      width: 80,
    },
    {
      headerName: "Moody Rating",
      field: "moodyRating",
      colId: "moodyRating",
      width: 80,
    },
    {
      headerName: "Urv Esg Score",
      field: "urvEsgScore",
      colId: "urvEsgScore",
      width: 80,
    },
    {
      headerName: "Industry One",
      field: "levelOneName",
      colId: "levelOneName",
      width: 80,
    },
    {
      headerName: "Industry Two",
      field: "levelTwoName",
      colId: "levelTwoName",
      width: 80,
    },
    {
      headerName: "Industry Three",
      field: "levelThreeName",
      colId: "levelThreeName",
      width: 80,
    },
    {
      headerName: "Industry Four",
      field: "levelFourName",
      colId: "levelFourName",
      width: 80,
    },
    {
      headerName: "Iboxx Level Four Name",
      field: "iboxxLevelFourName",
      colId: "iboxxLevelFourName",
      width: 80,
    },
    {
      headerName: "Libor Zero Volatility Spread",
      field: "liborZeroVolatilitySpread",
      colId: "liborZeroVolatilitySpread",
      width: 80,
    },
    {
      headerName: "RR Client Level One Scheme",
      field: "rrClientLevelOneScheme",
      colId: "rrClientLevelOneScheme",
      width: 80,
    },
    {
      headerName: "RR Client Level Two Scheme",
      field: "rrClientLevelTwoScheme",
      colId: "rrClientLevelTwoScheme",
      width: 80,
    },
    {
      headerName: "RR Client Level Three Scheme",
      field: "rrClientLevelThreeScheme",
      colId: "rrClientLevelThreeScheme",
      width: 80,
    },
    {
      headerName: "RR Client Level Four Scheme",
      field: "rrClientLevelFourScheme",
      colId: "rrClientLevelFourScheme",
      width: 80,
    },
    {
      headerName: "RR Client Level Five Scheme",
      field: "rrClientLevelFiveScheme",
      colId: "rrClientLevelFiveScheme",
      width: 80,
    },
    {
      headerName: "RR Client Level Six Scheme",
      field: "rrClientLevelSixScheme",
      colId: "rrClientLevelSixScheme",
      width: 80,
    },
    {
      headerName: "To Trader Date",
      field: "toTraderDate",
      colId: "toTraderDate",
      width: 80,
    },
    {
      headerName: "Muni Level One",
      field: "muniLevelOne",
      colId: "muniLevelOne",
      width: 80,
    },
    {
      headerName: "Muni Level Two",
      field: "muniLevelTwo",
      colId: "muniLevelTwo",
      width: 80,
    },
    {
      headerName: "Muni Obligor",
      field: "muniObligor",
      colId: "muniObligor",
      width: 80,
    },
    {
      headerName: "EM Level Seven Scheme",
      field: "emergingMarketLevelSevenScheme",
      colId: "emergingMarketLevelSevenScheme",
      width: 80,
    },
    {
      headerName: "Prc Src Name",
      field: "prcSrcName",
      colId: "prcSrcName",
      width: 100,
    },
    {
      headerName: "Moody Sp Fitch Average Split Rating",
      field: "moodySpFitchAverageSplitRating",
      colId: "moodySpFitchAverageSplitRating",
      width: 80,
    },
    {
      headerName: "Moody Sp Fitch Average Split Rating BandName",
      field: "moodySpFitchAverageSplitRatingBandName",
      colId: "moodySpFitchAverageSplitRatingBandName",
      width: 80,
    },
    {
      headerName: "Moody Sp Fitch Average Split Rating Mapped",
      field: "moodySpFitchAverageSplitRatingMapped",
      colId: "moodySpFitchAverageSplitRatingMapped",
      width: 80,
    },
    {
      headerName: "Yield To Worst",
      field: "yieldToWorst",
      colId: "yieldToWorst",
      width: 80,
    },
    {
      headerName: "First Coupon Date",
      field: "firstCouponDate",
      colId: "firstCouponDate",
      width: 80,
    },
    {
      headerName: "Coupon Frequency",
      field: "couponFrequency",
      colId: "couponFrequency",
      width: 80,
    },
    {
      headerName: "Manager Last Name",
      field: "managerLastName",
      colId: "managerLastName",
      width: 120,
    },
    {
      headerName: "EM Custom Industry Level Code",
      field: "emCustomIndustryLevelCode",
      colId: "emCustomIndustryLevelCode",
      width: 80,
    },
    {
      headerName: "EM Custom Industry Level Name",
      field: "emCustomIndustryLevelName",
      colId: "emCustomIndustryLevelName",
      width: 80,
    },
    {
      headerName: "Country Of Risk",
      field: "countryOfRisk",
      colId: "countryOfRisk",
      width: 80,
    },
    {
      headerName: "Country Of Risk Name",
      field: "countryOfRiskName",
      colId: "countryOfRiskName",
      width: 80,
    },
    {
      headerName: "Country Of Domicile",
      field: "countryOfDomicile",
      colId: "countryOfDomicile",
      width: 80,
    },
    {
      headerName: "Country Of Domicile Name",
      field: "countryOfDomicileName",
      colId: "countryOfDomicileName",
      width: 80,
    },
    {
      headerName: "Rule 144a Regs Text",
      field: "rule144ARegsText",
      colId: "rule144ARegsText",
      width: 80,
    },
    {
      headerName: "Spread",
      field: "spread",
      colId: "spread",
      width: 80,
    },
    {
      headerName: "Muni Tax Treatment",
      field: "muniTaxTreatment",
      colId: "muniTaxTreatment",
      width: 80,
    },

    {
      headerName: "Accrued Interest",
      field: "accruedInterest",
      colId: "accruedInterest",
      width: 80,
    },
    {
      headerName: "PAM Book Value",
      field: "pamBookValue",
      colId: "pamBookValue",
      width: 80,
    },
    {
      headerName: "PAM Units",
      field: "pamUnits",
      colId: "pamUnits",
      width: 80,
    },
    {
      headerName: "PAM Amort Price",
      field: "pamAmortPrice",
      colId: "pamAmortPrice",
      width: 80,
    },
    {
      headerName: "PAM Realized Gl",
      field: "pamRealizedGl",
      colId: "pamRealizedGl",
      width: 80,
    },
    {
      headerName: "Account Guideline Rating",
      field: "accountGuidelineRating",
      colId: "accountGuidelineRating",
      width: 80,
    },
    {
      headerName: "Default Rating",
      field: "defaultRating",
      colId: "defaultRating",
      width: 80,
    },
    {
      headerName: "MarketCode",
      field: "marketCode",
      colId: "marketCode",
      width: 80,
    },
    {
      headerName: "PFB Amount",
      field: "pfbAmount",
      colId: "pfbAmount",
      width: 80,
    },
    {
      headerName: "Weighted PFB Amount",
      field: "weightedPfbAmount",
      colId: "weightedPfbAmount",
      width: 80,
    },
    {
      headerName: "Purchased Yield",
      field: "purchasedYield",
      colId: "purchasedYield",
      width: 80,
    },
    {
      headerName: "Sale Yield",
      field: "saleYield",
      colId: "saleYield",
      width: 80,
    },
    {
      headerName: "Original Face Traded",
      field: "originalFaceTraded",
      colId: "originalFaceTraded",
      width: 80,
    },
    {
      headerName: "Interval",
      field: "interval",
      colId: "interval",
      width: 80,
    },
    {
      headerName: "Bloomberg Green Bond Loan Ind",
      field: "bloombergGreenBondLoanInd",
      colId: "bloombergGreenBondLoanInd",
      width: 80,
    },
    {
      headerName: "Ges Company Level Bloomberg Green Bond Ind",
      field: "gesCompanyLevelBloombergGreenBondInd",
      colId: "gesCompanyLevelBloombergGreenBondInd",
      width: 80,
    },
    {
      headerName: "Green Social Sust Bond Ind Text",
      field: "greenSocialSustBondIndText",
      colId: "greenSocialSustBondIndText",
      width: 80
    },
    {
      headerName: "Portfolio Trading Flag",
      field: "portfolioTradingFlag",
      colId: "portfolioTradingFlag",
      width: 80
    },

    {
      headerName: "BB Short Name",
      field: "bbShortName",
      colId: "bbShortName",
      width: 80
    },
    {
      headerName: "IG HY Best",
      field: "igHyBest",
      colId: "igHyBest",
      width: 80
    },
    {
      headerName: "IG HY Lehman",
      field: "igHyLehman",
      colId: "igHyLehman",
      width: 80
    },
    {
      headerName: "IG HY NR Lehman",
      field: "igHyNrLehman",
      colId: "igHyNrLehman",
      width: 80
    },
    {
      headerName: "Industry Sector",
      field: "industrySector",
      colId: "industrySector",
      width: 80
    },
    {
      headerName: "EM Team Country Of Risk Name",
      field: "emTeamCountryOfRiskName",
      colId: "emTeamCountryOfRiskName",
      width: 80
    },
    {
      headerName: "GPS Program Contract",
      field: "gpsProgramContract",
      colId: "gpsProgramContract",
      width: 80
    },
    {
      headerName: "Program Sponsor",
      field: "programSponsor",
      colId: "programSponsor",
      width: 80
    },
    {
      headerName: "Id Bb Ultimate Parent Co",
      field: "idBbUltimateParentCo",
      colId: "idBbUltimateParentCo",
      width: 80
    },
    {
      headerName: "Asset Class",
      field: "assetClass",
      colId: "assetClass",
      width: 80
    },
    {
      headerName: "Id BB Global Company",
      field: "idBbGlobalCompany",
      colId: "idBbGlobalCompany",
      width: 80
    },
    {
      headerName: "Invest Platform Description",
      field: "investPlatformDescription",
      colId: "investPlatformDescription",
      width: 80
    },
    /*
    {
      headerName: "Clean Market Value Plus Accrued",
      field: "cleanMarketValuePlusAccrued",
      colId: "cleanMarketValuePlusAccrued",
      width: 80
    },
    */
    {
      headerName: "Company Name",
      field: "companyName",
      colId: "companyName",
      width: 80
    },
    {
      headerName: "Issuer Name",
      field: "issuerName",
      colId: "issuerName",
      width: 80
    },
    {
      headerName: "Fx Rate",
      field: "fxRate",
      colId: "fxRate",
      width: 80
    },
    {
      headerName: "Duration",
      field: "duration",
      colId: "duration",
      width: 80
    },
    {
      headerName: "Analyst Name",
      field: "analystName",
      colId: "analystName",
      width: 80
    },
    {
      headerName: "Analyst Last Name",
      field: "analystLastName",
      colId: "analystLastName",
      width: 80
    },

    {
      headerName: "FD custom 1",
      field: "FD_custom_1",
      colId: "FD_custom_1",
      width: 80
    },
    {
      headerName: "FD custom 2",
      field: "FD_custom_2",
      colId: "FD_custom_2",
      width: 80
    },
    {
      headerName: "FD custom 3",
      field: "FD_custom_3",
      colId: "FD_custom_3",
      width: 80
    },
    {
      headerName: "FD custom 4",
      field: "FD_custom_4",
      colId: "FD_custom_4",
      width: 80
    },
    {
      headerName: "FD Custom Theme 1",
      field: "FD_Custom_Theme_1",
      colId: "FD_Custom_Theme_1",
      width: 80
    },
    {
      headerName: "FD Custom Theme 2",
      field: "FD_Custom_Theme_2",
      colId: "FD_Custom_Theme_2",
      width: 80
    },
    {
      headerName: "Issue Date",
      field: "issueDate",
      colId: "issueDate",
      width: 80
    },
    {
      headerName: "Issue Price",
      field: "issuePrice",
      colId: "issuePrice",
      width: 80
    },
    {
      headerName: "FD Marketing 1",
      field: "fdMarketing1",
      colId: "fdMarketing1",
      width: 80
    },
    {
      headerName: "Account Total Market Value USD",
      field: "accountTotalMarketValueUSD",
      colId: "accountTotalMarketValueUSD",
      width: 100,
    },
    {
      headerName: "Rating Loomis Quality",
      field: "ratingLoomisQuality",
      colId: "ratingLoomisQuality",
      width: 100,
    },
    {
      headerName: "Placement Type",
      field: "placementType",
      colId: "placementType",
      width: 100,
    },
    {
      headerName: "Settled Interest Base",
      field: "settledInterestBase",
      colId: "settledInterestBase",
      width: 100,
    },
    {
      headerName: "Settled Interest Local",
      field: "settledInterestLocal",
      colId: "settledInterestLocal",
      width: 100,
    },
    {
      headerName: "Comment Trader Yield",
      field: "commentTraderYield",
      colId: "commentTraderYield",
      width: 100,
    },
    {
      headerName: "Comment Trader Spread",
      field: "commentTraderSpread",
      colId: "commentTraderSpread",
      width: 100,
    },
  ];
  
};

export const useColumnDefinitionsFromCommitedState = () => {
  const defaultColumnDefinition = useSelector(
    (state) =>
      state["tradehistoryAttribute"][SelectionState.COMMITTED]["columnDef"]
  );
  const betasColumnDefs = useBetaColumnDefinitions();
  const holdingColumnDefs = useSelector(holdingColumnDef);
  const showRealizedGl = useSelector(
    selectSelectedIsDisplayRgl(SelectionState.COMMITTED)
  );

  const def = [...defaultColumnDefinition, ...betasColumnDefs, ...holdingColumnDefs]
  if (showRealizedGl) {
    def.push(
      {
        headerName: "Amort Price",
        field: "amortPrice",
        colId: "amortPrice",
      },
      {
        headerName: "Amort Realized GL",
        field: "realizedGl",
        colId: "realizedGl",
      }
    );
    return def;
  }
  return def;
};
